import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

/*----- Serbian Translations -----*/
import srHome from "./locales/sr/home.json";
import srLinks from "./locales/sr/links.json";
import srGallery from "./locales/sr/gallery.json";
import srMenu from "./locales/sr/menu.json";
import srAboutUs from "./locales/sr/about-us.json";
import srApartments from "./locales/sr/apartments.json";
import srPlayroom from "./locales/sr/playroom.json";
import srGreatHall from "./locales/sr/great-hall.json";
import srCrystalHall from "./locales/sr/crystal-hall.json";
import srSmallHall from "./locales/sr/small-hall.json";
import srFooter from "./locales/sr/footer.json";

/*----- English Translations -----*/
import enHome from "./locales/en/home.json";
import enLinks from "./locales/en/links.json";
import enGallery from "./locales/en/gallery.json";
import enMenu from "./locales/en/menu.json";
import enAboutUs from "./locales/en/about-us.json";
import enApartments from "./locales/en/apartments.json";
import enPlayroom from "./locales/en/playroom.json";
import enGreatHall from "./locales/en/great-hall.json";
import enCrystalHall from "./locales/en/crystal-hall.json";
import enSmallHall from "./locales/en/small-hall.json";
import enFooter from "./locales/en/footer.json";

const resources = {
  sr: {
    home: srHome,
    links: srLinks,
    gallery: srGallery,
    menu: srMenu,
    about_us: srAboutUs,
    apartments: srApartments,
    playroom: srPlayroom,
    great_hall: srGreatHall,
    crystal_hall: srCrystalHall,
    small_hall: srSmallHall,
    footer: srFooter,
  },
  en: {
    home: enHome,
    links: enLinks,
    gallery: enGallery,
    menu: enMenu,
    about_us: enAboutUs,
    apartments: enApartments,
    playroom: enPlayroom,
    great_hall: enGreatHall,
    crystal_hall: enCrystalHall,
    small_hall: enSmallHall,
    footer: enFooter,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "sr",
    defaultNS: "home",
    ns: ["home"],
    interpolation: {
      escapeValue: false,
    },
    debug: true,
  });
